<img [src]="imgSrc$ | async" />
<div *ngIf="marqueName" class="marque">{{ marqueName }}</div>
